import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getProviderInItems } from "store/provider-dashboard/provider-dashboard-action"
import { useSearchParams } from "react-router-dom"
import ProviderChartInItemsList from "components/ProviderDashboard/ProviderItems/ProviderChartInItemsList"
import { providerDashboardAction } from "store/provider-dashboard/provider-dashboard-slice"

const ProviderChartInItems = () => {
  const dispatch = useDispatch()

  const [searchParams] = useSearchParams()

  // get params from url parameter
  const getParams = {
    itemId: searchParams.get("itemId"),
    from: searchParams.get("from") !== "null" ? searchParams.get("from") : null,
    to: searchParams.get("to") !== "null" ? searchParams.get("to") : null,
    type: searchParams.get("type"),
  }
  const type = searchParams.get("type")
  const ProviderInItems = useSelector(
    state => state.providerDashboard.ProviderInItems
  )

  const buildParams = (page = 1, perPage = 10) => ({
    ...getParams,
    page,
    per_page: perPage,
  })

  // get receipts based params
  useEffect(() => {
    dispatch(getProviderInItems(buildParams(1)))

    return () => {
      dispatch(providerDashboardAction.resetProviderInItems())
    }
  }, [])

  const onPageClick = link => {
    let page = 1
    if (link?.url) {
      const match = link.url.match(/[?&]page=(\d+)/)
      if (match) {
        page = match[1]
      }
    }
    dispatch(getProviderInItems(buildParams(page)))
  }

  return (
    // Provider Receipt Item list components
    <ProviderChartInItemsList
      data={ProviderInItems?.data?.data}
      loading={ProviderInItems?.loading}
      type={type}
      totalQuantity={ProviderInItems?.data?.total_quantity}
      pagination={{ meta: ProviderInItems?.data?.meta, onPageClick }}
    />
  )
}

export default ProviderChartInItems
